/**
 * Languages settings page.
 */
import LanguageSettingsTemplate from '@components/templates/languageSettings';

/**
 * Languages page component.
 */
export default function LanguagesSettingsPage() {
  return <LanguageSettingsTemplate />;
}
